import { Box, SxProps, Theme, useMediaQuery } from '@mui/material'
import { MIN_WIDTH_SPINNING_LOGO } from 'components/pages/login/SpinningLogo'
import useWindowSize from 'hooks/useWindowSize'

type Props = {
  container1: {
    content: React.ReactNode
    sx?: SxProps
  }
  container2: {
    content: React.ReactNode
    sx?: SxProps
  }
}

const NewAuthTemplate: React.FC<Props> = ({ container1, container2 }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
  const { width } = useWindowSize()

  if (!isMobile)
    return (
      <Box display="flex" height="100vh">
        <Box
          sx={{
            flex: '1',
            bgcolor: 'var(--light-blue)',
            height: '100%',
            width: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            ...container1.sx,
          }}
        >
          {container1.content}
        </Box>

        <Box
          sx={{
            width: '50%',
            minWidth: '40%',
            maxWidth: '598px',
            textAlign: 'center',
            height: '100%',
            boxSizing: 'border-box',
            bgcolor: 'var(--light-blue)',
            ...container2.sx,
          }}
        >
          <Box
            sx={{
              borderRadius: '16px 0 0 16px',
              bgcolor: 'white',
              p: '24px',
              height: '100%',
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              overflowY: 'scroll',
            }}
          >
            {container2.content}
          </Box>
        </Box>
      </Box>
    )

  return (
    <Box>
      <Box
        sx={{
          bgcolor: '#2475FF',
          height: width < MIN_WIDTH_SPINNING_LOGO ? '144px' : '240px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          position: 'relative',
          ...container1.sx,
        }}
      >
        {container1.content}
      </Box>

      <Box sx={{ textAlign: 'center', p: '24px', flex: 1, ...container2.sx }}>{container2.content}</Box>
    </Box>
  )
}

export default NewAuthTemplate
